import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { FileCopy as ContentCopyIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../../controls/contextMenu/models/MenuOptionType";
import type { CatalogMaterial } from "../../../models/CatalogMaterial";

type Props = {
  setMaterial: (material: CatalogMaterial) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewMaterial: () => void;
};
export const useMaterialsOptionsFunctions = ({
  setMaterial,
  setShowModal,
  handleNewMaterial,
}: Props) => {
  const getMenuOptions = (data: CatalogMaterial) => {
    let options: MenuOptionType[] = [
      {
        name: "New Material",
        key: "new_material",
        onClick: () => {
          handleNewMaterial();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit Material",
          key: "edit_material",
          onClick: () => {
            setMaterial(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete Material",
          key: "delete_material",
          onClick: () => {
            setMaterial(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
        {
          name: "Duplicate Material",
          key: "duplicate_material",
          onClick: () => {
            setMaterial({
              ...data,
              MaterialName: `${data.MaterialName} - Copy`,
              MaterialId: null,
            });
            setShowModal("new");
          },
          icon: <ContentCopyIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
